<div class="container campaigns-offers-list mb-lg-3">
  <ng-container *ngIf="activeOffers$ | async as activeOffers">
    <ng-container *ngIf="activeOffers.Offers?.length > 0 || activeOffers.Vouchers?.length > 0">
      <div class="offer-items">
        <div class="offer-items-header mt-4 mb-2">
          <h5 class="mb-0 campaign-offer-subheading font-size-16">{{ 'campaign.offers.subheading' | translate }}</h5>
          <a class="offer-items-header-link" routerLink="{{ showAllOffersLink }}" *ngIf="showAllOffers">
            <span class="campaign-offer-show-all fw-normal me-2">{{ 'wallet.show.all' | translate }}</span>
            <span class="icon material-icons offer-items-header-link-icon" aria-hidden="true">arrow_forward_ios</span>
          </a>
        </div>
        <owl-carousel-o [options]="customOptions" (dragging)="isDragging = $event.dragging">
          <ng-container *ngFor="let offer of activeOffers.Offers">
            <ng-template carouselSlide>
              <fgb-campaigns-v2-list-item
                [campaignEntitlement]="offer"
                [stopLink]="isDragging"
                [owlRouterLink]="'/campaign-v2/details/offer/' + offer.CampaignId"
              ></fgb-campaigns-v2-list-item>
            </ng-template>
          </ng-container>
          <ng-container *ngFor="let voucher of activeOffers.Vouchers">
            <ng-template carouselSlide>
              <fgb-campaigns-v2-voucher-list-item
                [campaignEntitlement]="voucher"
                [stopLink]="isDragging"
                [owlRouterLink]="'/campaign-v2/details/voucher/' + voucher.CampaignId"
              ></fgb-campaigns-v2-voucher-list-item>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </ng-container>
  </ng-container>
</div>
